export default "<span class=\"error error-message\" [ngClass]=\"{ active: showError }\">\r\n  <ng-content></ng-content>\r\n</span>\r\n";